"use strict";
import { getNativeAddress, getWrappedNativeAddress } from "constants/uniswapAddresses";
import { DEFAULT_NATIVE_ADDRESS } from "features/chains/chainInfo";
import { toSupportedChainId } from "features/chains/utils";
import { areAddressesEqual, getValidAddress } from "utils/addresses";
export function currencyId(currencyOrTradeableAsset) {
  if (!currencyOrTradeableAsset) {
    return void 0;
  }
  return buildCurrencyId(
    currencyOrTradeableAsset.chainId,
    "isNative" in currencyOrTradeableAsset ? currencyAddress(currencyOrTradeableAsset) : currencyOrTradeableAsset.address
  );
}
export function buildCurrencyId(chainId, address) {
  return `${chainId}-${address}`;
}
export function isCurrencyIdValid(_currencyId) {
  try {
    const [chainId, address] = _currencyId.split("-");
    const validAddress = getValidAddress(address);
    const validChainId = toSupportedChainId(chainId);
    return !!validChainId && !!validAddress;
  } catch (error) {
    return false;
  }
}
export function buildNativeCurrencyId(chainId) {
  return buildCurrencyId(chainId, getNativeAddress(chainId));
}
export function buildWrappedNativeCurrencyId(chainId) {
  return buildCurrencyId(chainId, getWrappedNativeAddress(chainId));
}
export function areCurrencyIdsEqual(id1, id2) {
  return id1.toLowerCase() === id2.toLowerCase();
}
export function areCurrenciesEqual(currency1, currency2) {
  if (!(currency1 && currency2)) {
    return currency1 === currency2;
  }
  return areCurrencyIdsEqual(currencyId(currency1), currencyId(currency2));
}
export function currencyAddress(currency) {
  if (currency.isNative) {
    return getNativeAddress(currency.chainId);
  }
  return currency.address;
}
export const NATIVE_ANALYTICS_ADDRESS_VALUE = "NATIVE";
export function getCurrencyAddressForAnalytics(currency) {
  if (currency.isNative) {
    return NATIVE_ANALYTICS_ADDRESS_VALUE;
  }
  return currency.address;
}
export const isNativeCurrencyAddress = (chainId, address) => {
  if (!address) {
    return true;
  }
  const lowerAddress = address.toLowerCase();
  if (lowerAddress === "native" || lowerAddress === "eth") {
    return true;
  }
  return areAddressesEqual(address, getNativeAddress(chainId));
};
export function currencyIdToAddress(_currencyId) {
  const currencyIdParts = _currencyId.split("-");
  if (!currencyIdParts[1]) {
    throw new Error(`Invalid currencyId format: ${_currencyId}`);
  }
  return currencyIdParts[1];
}
export function currencyIdToGraphQLAddress(_currencyId) {
  if (!_currencyId) {
    return null;
  }
  const address = currencyIdToAddress(_currencyId);
  const chainId = currencyIdToChain(_currencyId);
  if (!chainId) {
    return null;
  }
  if (isNativeCurrencyAddress(chainId, address)) {
    return null;
  }
  return address.toLowerCase();
}
export function currencyIdToChain(_currencyId) {
  return toSupportedChainId(_currencyId.split("-")[0]);
}
export function isDefaultNativeAddress(address) {
  return areAddressesEqual(address, DEFAULT_NATIVE_ADDRESS);
}
